module.exports = "/_next/static/images/Build@2x-1b2aeae0802249e120604a1d1316db1e.webp";